export default __webpack_public_path__ + "static/media/phone-line.180bb755.svg";